import { DerivedMemberType, MemberInfo, PetType } from "./member";

export enum TypeAheadCategory {
  VACCINATION = "vaccinations",
  LAB_TEST = "lab_tests",
}

export interface TypeAhead {
  id: string;
  category: string;
  values: string[];
  reviewValues: string[];
}

export interface CreateTypeAheadDto {
  category: string;
  values: string[];
  reviewValues: string[];
}

export interface UpdateTypeAheadDto {
  category: string;
  values: string[];
  reviewValues: string[];
}

export interface SearchDto {
  search: string;
}

export const getCategoryKey = (
  category: TypeAheadCategory,
  memberInfo: MemberInfo
) => {
  switch (memberInfo.derivedMemberType) {
    case DerivedMemberType.A:
      return category + "_h";
    case DerivedMemberType.C:
      return category + "_child";
    case DerivedMemberType.P:
      return memberInfo.otherAttrs?.petType === PetType.CAT
        ? category + "_p_cat"
        : category + "_p_dog";
    default:
      return category;
  }
};

export const getSuffix: (memberInfo: MemberInfo) => string = (
  memberInfo: MemberInfo
) => {
  switch (memberInfo.derivedMemberType) {
    case DerivedMemberType.A:
      return "_h";
    case DerivedMemberType.C:
      return "_child";
    case DerivedMemberType.P:
      return memberInfo.otherAttrs?.petType === PetType.CAT
        ? "_p_cat"
        : "_p_dog";
    default:
      return "";
  }
};
